const heroModuleEle = document.querySelector('.hero-module');

if (heroModuleEle) {
  const siteHeader = document.querySelector('.site-header');

  const heroContentTimeline = gsap.timeline();
  heroContentTimeline.to(
    ['.hero-module__content .title', '.hero-module__text', '.hero-module__button'],
    { y: 0, autoAlpha: 1, duration: 1, stagger: 0.1, ease: 'back.inOut(2)' },
    'imageStart',
  );

  const aboutSection = document.querySelector('.sc-about-us');

  if (aboutSection) {
    const aboutSectionHeight = aboutSection.clientHeight;
    const windowHeight = window.innerHeight;

    const mm = gsap.matchMedia();

    // Initialize ScrollMagic Controller
    const controller = new ScrollMagic.Controller();

    // Sticky Animation
    mm.add('(min-width: 1023px)', () => {
      const stickyTween = gsap.to(['.hero-module__bg', '.hero-module__content', '.hero-module__sticky-background'], {
        y: '40vh',
        autoAlpha: 0.8,
      });

      new ScrollMagic.Scene({
        triggerElement: siteHeader.clientHeight,
        triggerHook: 0,
        duration: '100%',
      })
        .setTween(stickyTween)
        .addTo(controller);
    });

    mm.add('(max-width: 1022px)', () => {
      const stickyTween = gsap.to(['.hero-module__bg', '.hero-module__content', '.hero-module__sticky-background'], {
        y: 100,
        autoAlpha: 0.8,
      });

      new ScrollMagic.Scene({
        triggerElement: siteHeader.clientHeight,
        triggerHook: 0,
        duration: '100%',
      })
        .setTween(stickyTween)
        .addTo(controller);
    });

    // if (isLocal()) {
    //   stickyScene.addIndicators({ name: 'Sticky' });
    // }

    // Cup Animation
    mm.add('(min-width: 1023px)', () => {
      const cupTimeline = gsap
        .timeline()
        .to('.hero-module .hero-module__coffee-cup', { top: '50%', left: '-1vw' })
        .to('.hero-module .coffee-cup img', { scale: 1.06, rotate: '-3' }, '<')
        .to('.hero-module .hero-module__coffee-cup', { top: `${aboutSectionHeight * 0.78}px`, left: '-5vw' })
        .to('.hero-module .coffee-cup img', { rotate: '-8' }, '<');

      new ScrollMagic.Scene({
        triggerElement: siteHeader.clientHeight,
        triggerHook: 0,
        duration: '100%',
      })
        .setTween(cupTimeline)

        .addTo(controller);
    });

    mm.add('(max-width: 1022px)', () => {
      const cupTimeline = gsap
        .timeline()
        .to('.hero-module .hero-module__coffee-cup', { top: '150px' })
        .to('.hero-module .coffee-cup img', { rotate: '-3', right: '-10' }, '<')
        .to('.coffee-cup__video-bg, .coffee-cup__video', { left: '0' }, '<')
        .to('.hero-module .hero-module__coffee-cup', { top: '332px', left: '-100px' })
        .to('.hero-module .coffee-cup img', { rotate: '-8', right: '0' }, '<');

      new ScrollMagic.Scene({
        triggerElement: siteHeader.clientHeight,
        triggerHook: 0,
        duration: `${windowHeight * 0.8}px`,
      })
        .setTween(cupTimeline)
        .addTo(controller);
    });
  }
}
